import { createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';
import { geneAsyncAction } from 'services/actionConfigs';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { featureName, GetStaffListParams, IStaffDetailsType } from './constants';

const createAsync = geneAsyncAction(featureName);

const async = {
  getStaffList: createAsync<GetStaffListParams, IStaffDetailsType[]>('getStaffList'),
  getStaffDetail: createAsync<string, IStaffDetailsType>('getStaffDetail'),
};

export type IstaffReducerState = {
  isLoading: boolean;
  staffList: IStaffDetailsType[];
  staffDetail: IStaffDetailsType | null;
};

type MyState = IstaffReducerState;

const reducers = {
  uiInit: (state: MyState, {}: { payload: string }) => {
    state.isLoading = true;
  },
};
// @ts-ignore
const getCurrentState = (state: RootState): MyState => state['staff']; // ex: state['booking']

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector((state) => get(getCurrentState(state), key, defaultValue));

const selectors = {
  isLoading: () => selector('isLoading') as MyState['isLoading'],
  staffList: () => selector('staffList') as MyState['staffList'],
  staffDetail: () => selector('staffDetail') as MyState['staffDetail'],
};

const Slice = createSlice({
  name: featureName,
  initialState: {
    isLoading: false,
    staffList: [],
    staffDetail: null,
  } as MyState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(async.getStaffList.fetch, (state) => {
        state.isLoading = true;
      })
      .addCase(async.getStaffList.success, (state, { payload }) => {
        state.isLoading = false;
        state.staffList = payload;
      })
      .addCase(async.getStaffList.fail, (state) => {
        state.isLoading = false;
      })
      .addCase(async.getStaffDetail.fetch, (state) => {
        state.isLoading = true;
      })
      .addCase(async.getStaffDetail.success, (state, { payload }) => {
        state.isLoading = false;
        state.staffDetail = payload;
      })
      .addCase(async.getStaffDetail.fail, (state) => {
        state.isLoading = false;
      });
  },
});

const actions = {
  ...Slice.actions,
  async,
};
const reducer = Slice.reducer;

export { actions, reducer, selectors };
